import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Drawer } from 'primeng/drawer';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterLink, RouterLinkActive, Drawer, NgTemplateOutlet],
  templateUrl: './sidebar.html',
})
export class Sidebar {
  @Input() drawerOpen: boolean = false;
  @Output() drawerOpenChange = new EventEmitter<boolean>();
}
